import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageTitle from "../components/PageTitle";
import { articles } from "../data/mock";

export default function PatientEducation() {
  return (
    <div>
      <PageTitle title="Patient Education" crumbs={[{ label: "Patient Education" }]} />
      <section className="py-20 px-4 bg-[#fbf6ee]">
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
          {articles.map((a) => (
            <article key={a.slug} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow">
              <div className="relative">
                <img src={a.image} alt={a.title} className="w-full h-56 object-cover" />
                <div className="absolute top-4 left-4 w-16 h-16 rounded-full bg-amber-400 flex flex-col items-center justify-center text-[#1a1a1a] font-bold leading-tight shadow-md">
                  <span className="text-xl">{a.day}</span>
                  <span className="text-[10px] uppercase">{a.month}</span>
                </div>
              </div>
              <div className="p-6">
                <p className="text-xs text-gray-500 mb-2">By {a.author}</p>
                <h3 className="text-lg font-bold text-gray-900 mb-3 leading-snug hover:text-[#b81d24] transition-colors">
                  <Link to={`/articles/${a.slug}`}>{a.title}</Link>
                </h3>
                <p className="text-sm text-gray-600 mb-4">{a.excerpt}</p>
                <Link to={`/articles/${a.slug}`} className="inline-flex items-center gap-2 text-[#b81d24] font-semibold border-b-2 border-amber-400 pb-1 hover:gap-3 transition-all">
                  Continue Reading <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
